<template>
  <div class="rechargePayTop subpage">
    <Header ref="navBarRef" :is-sub-page="true" title="我的积分"></Header>
    <div class="content">
      <div class="rechargePayTop-list">
        <div class="rechargePayTop-item" :class="[selectItem==index?'select':'unSelect']" v-for="(item,index) in this.shopScore" :key="index" @click="select(index)">
          <div class="integral-number">{{item.score}}积分</div>
          <div class="integral-money">￥{{item.money/100}}</div>
        </div>
      </div>
      <div class="recharge-btn" @click="this.buyScore">
        <span class="recharge-font">充值</span>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import { queryShopScore } from '@/api/shop'

export default {
  name: '',
  data () {
    return {
      selectItem: '',
      shopScore: [
        {
          id: '',
          score: '',
          money: ''
        }
      ],
      selectScore: ''

    }
  },
  components: {
    Header
  },
  mounted () {
    console.log('123', 'getscoreList')
    this.getData()
  },
  methods: {
    select (index) {
      this.selectItem = index
      this.selectScore = this.shopScore[index]
    },
    getData () {
      queryShopScore({
        page: 1,
        size: 100
      }).then((res) => {
        this.shopScore.splice(0)
        const records = res.data.records
        records.sort(this.compare('sort'))

        records.forEach((item, idx) => {
          this.shopScore.push({
            id: item.scoreId,
            score: item.value,
            money: item.money
          })
        })
        this.selectScore = this.shopScore[0]
      })
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },
    buyScore () {
      this.$dfzhJsBridge.goPay({
        id: this.selectScore.id,
        score: this.selectScore.score,
        money: this.selectScore.money
      })
    }

  }
}
</script>

<style lang="stylus" scoped>
.content
  display flex
  flex-direction column
  .rechargePayTop-list
    display: flex
    justify-content: flex-start
    flex-wrap wrap
    .select
      background-color #874ED5
      color #fff
    .unSelect
      background-color #FFFFFF
      color #545454
    .rechargePayTop-item
      height 79px
      margin-left 15px
      margin-top 15px
      width 105px
      border-radius 5px
      border 1px solid #874DD5
      .integral-number
        margin-top 18px
        font-size 17px
      .integral-money
        margin-top 10px
  .recharge-btn
    position fixed
    bottom 52px
    display flex
    width 100%
    justify-content center
    align-items center
    .recharge-font
      width 301px
      height 44px
      background-color #874DD5
      line-height 44px
      font-size 16px
      color #fff
      border-radius 5px
</style>

<style lang="stylus">
body
  background-color #f7f7f7
</style>
